import { render } from "./SchoolSettings.vue?vue&type=template&id=e4010be2&scoped=true&ts=true"
import script from "./SchoolSettings.vue?vue&type=script&lang=ts"
export * from "./SchoolSettings.vue?vue&type=script&lang=ts"

import "./SchoolSettings.vue?vue&type=style&index=0&id=e4010be2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4010be2"]])

export default __exports__